import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    telephone: '',
    entreprise: '',
    sujet: 'devis',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          professionnel_id: null,
          nom: formData.nom,
          email: formData.email,
          telephone: formData.telephone,
          message: `[Entreprise: ${formData.entreprise}] [Sujet: ${formData.sujet}] ${formData.message}`
        }),
      });

      if (response.ok) {
        setStatus({
          type: 'success',
          message: 'Votre message a bien ete envoye ! Nous vous recontacterons sous 24h.'
        });
        setFormData({
          nom: '',
          email: '',
          telephone: '',
          entreprise: '',
          sujet: 'devis',
          message: ''
        });
      } else {
        throw new Error('Erreur serveur');
      }
    } catch (error) {
      setStatus({
        type: 'error',
        message: 'Une erreur est survenue. Veuillez reessayer ou nous contacter par telephone.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <Helmet>
        <title>Contact | Annuaire des Pros - E-Shop Pro Paris</title>
        <meta name="description" content="Contactez E-Shop Pro pour votre projet digital. Developpement web, applications mobiles, CRM sur mesure a Paris et Ile-de-France. Devis gratuit sous 48h." />
        <link rel="canonical" href="https://annuaire.e-shop-pro.fr/contact" />
      </Helmet>

      {/* Hero */}
      <section className="contact-hero">
        <div className="container">
          <h1>Contactez-nous</h1>
          <p className="subtitle">Un projet ? Une question ? Nous sommes la pour vous accompagner.</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Form */}
            <div className="contact-form-wrapper">
              <h2>Envoyez-nous un message</h2>
              <p>Remplissez le formulaire ci-dessous et nous vous repondrons sous 24h.</p>

              {status.message && (
                <div className={`status-message ${status.type}`}>
                  {status.message}
                </div>
              )}

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="nom">Nom complet *</label>
                    <input
                      type="text"
                      id="nom"
                      name="nom"
                      value={formData.nom}
                      onChange={handleChange}
                      required
                      placeholder="Votre nom"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="votre@email.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="telephone">Telephone</label>
                    <input
                      type="tel"
                      id="telephone"
                      name="telephone"
                      value={formData.telephone}
                      onChange={handleChange}
                      placeholder="06 12 34 56 78"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="entreprise">Entreprise</label>
                    <input
                      type="text"
                      id="entreprise"
                      name="entreprise"
                      value={formData.entreprise}
                      onChange={handleChange}
                      placeholder="Nom de votre entreprise"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="sujet">Sujet *</label>
                  <select
                    id="sujet"
                    name="sujet"
                    value={formData.sujet}
                    onChange={handleChange}
                    required
                  >
                    <option value="devis">Demande de devis</option>
                    <option value="site-web">Creation site web</option>
                    <option value="application">Application mobile</option>
                    <option value="crm">CRM / Logiciel sur mesure</option>
                    <option value="seo">Referencement SEO</option>
                    <option value="annuaire">Inscription annuaire</option>
                    <option value="autre">Autre</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Decrivez votre projet ou votre demande..."
                  ></textarea>
                </div>

                <button type="submit" className="btn-submit" disabled={loading}>
                  {loading ? 'Envoi en cours...' : 'Envoyer le message'}
                </button>
              </form>
            </div>

            {/* Info */}
            <div className="contact-info">
              <div className="info-card">
                <h3>Informations de contact</h3>
                
                <div className="info-item">
                  <div className="info-icon">📍</div>
                  <div>
                    <strong>Adresse</strong>
                    <p>Paris, Ile-de-France</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">📞</div>
                  <div>
                    <strong>Telephone</strong>
                    <p><a href="tel:+33743678501">07 43 67 85 01</a></p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">✉️</div>
                  <div>
                    <strong>Email</strong>
                    <p><a href="mailto:contact@e-shop-pro.fr">contact@e-shop-pro.fr</a></p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">🌐</div>
                  <div>
                    <strong>Site web</strong>
                    <p><a href="https://e-shop-pro.fr" target="_blank" rel="noopener noreferrer">e-shop-pro.fr</a></p>
                  </div>
                </div>
              </div>

              <div className="info-card hours-card">
                <h3>Horaires</h3>
                <div className="hours-list">
                  <div className="hours-item">
                    <span>Lundi - Vendredi</span>
                    <span>9h00 - 18h00</span>
                  </div>
                  <div className="hours-item">
                    <span>Samedi</span>
                    <span>Sur RDV</span>
                  </div>
                  <div className="hours-item">
                    <span>Dimanche</span>
                    <span>Ferme</span>
                  </div>
                </div>
              </div>

              <div className="info-card response-card">
                <div className="response-icon">⚡</div>
                <h3>Reponse rapide</h3>
                <p>Nous nous engageons a vous repondre sous <strong>24 heures</strong> maximum.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map or CTA */}
      <section className="contact-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Vous preferez echanger de vive voix ?</h2>
            <p>Appelez-nous directement ou prenez rendez-vous pour une consultation gratuite.</p>
            <a href="tel:+33743678501" className="btn-call">
              📞 Appeler maintenant
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
